import { authFetchPost } from 'store/utils/authFetch';
import { USER_SUCCESS } from './user';

export const RUN_OVERVIEW_TUTORIAL = 'RUN_OVERVIEW_TUTORIAL';
export const COMPLETE_OVERVIEW_TUTORIAL = 'COMPLETE_OVERVIEW_TUTORIAL';

export const RUN_KNOWLEDGE_GRAPH_TUTORIAL = 'RUN_KNOWLEDGE_GRAPH_TUTORIAL';
export const COMPLETE_KNOWLEDGE_GRAPH_TUTORIAL = 'COMPLETE_KNOWLEDGE_GRAPH_TUTORIALL';

export const RUN_WHAT_CAN_I_ASK_TUTORIAL = 'RUN_WHAT_CAN_I_ASK_TUTORIAL';
export const COMPLETE_WHAT_CAN_I_ASK_TUTORIAL = 'COMPLETE_WHAT_CAN_I_ASK_TUTORIALL';

export const COMPLETE_FIRST_ACCESS_TUTORIAL = 'COMPLETE_FIRST_ACCESS_TUTORIAL';

export const TUTORIAL_FINISHED_REQUEST = 'TUTORIAL_FINISHED_REQUEST';
export const TUTORIAL_FINISHED_FAIL = 'TUTORIAL_FINISHED_FAIL';

export function runOverviewTutorial() {
  return {
    type: RUN_OVERVIEW_TUTORIAL
  };
}

export function runWhatCanIAskTutorial() {
  return {
    type: RUN_WHAT_CAN_I_ASK_TUTORIAL
  };
}

export function completeWhatCanIAskTutorial() {
  return {
    type: COMPLETE_WHAT_CAN_I_ASK_TUTORIAL
  };
}

export function runKnowledgeGraphTutorial() {
  return {
    type: RUN_KNOWLEDGE_GRAPH_TUTORIAL
  };
}

export function completeKnowledgeGraphTutorial() {
  return {
    type: COMPLETE_KNOWLEDGE_GRAPH_TUTORIAL
  };
}

export function completeOverviewTutorial() {
  return {
    type: COMPLETE_OVERVIEW_TUTORIAL
  };
}

export const completeFirstAccessTutorial = () => {
  return dispatch => {
    dispatch(completeOverviewTutorial());

    dispatch({ type: COMPLETE_FIRST_ACCESS_TUTORIAL });
  };
};

export const finishedTutorial = (tutorialId, isCompleted) => {
  return dispatch => {
    const newTutorial = { id: tutorialId, name: tutorialId, isUncompleted: false };
    dispatch({ type: TUTORIAL_FINISHED_REQUEST, data: newTutorial });

    authFetchPost(
      '/tutorial',
      dispatch,
      {
        tutorialId,
        isCompleted
      },
      { addKgId: true }
    )
      .then(response => {
        if (response.ok) {
          console.log('finished tutorial is a success response');
        } else {
          console.log('finished tutorial is a BAD response');
          dispatch({ type: TUTORIAL_FINISHED_FAIL });
        }
      })
      .then(response => {})
      .catch(error => console.log('ERROR', error));
  };
};

// describe a reducer
export const defaultTutorialState = {
  runOverviewTutorial: false,
  runWhatCanIAskTutorial: false,
  runKnowledgeGraphTutorial: false,
  hasFinishedFirstAccessTutorial: false,
  tutorials: [],
  uncompletedTutorials: []
};

export function tutorial(state = defaultTutorialState, action) {
  switch (action.type) {
    case RUN_OVERVIEW_TUTORIAL:
      return {
        ...state,
        runOverviewTutorial: true
      };

    case RUN_KNOWLEDGE_GRAPH_TUTORIAL:
      return {
        ...state,
        runKnowledgeGraphTutorial: true
      };

    case RUN_WHAT_CAN_I_ASK_TUTORIAL:
      return {
        ...state,
        runWhatCanIAskTutorial: true
      };

    case COMPLETE_OVERVIEW_TUTORIAL:
      return {
        ...state,
        runOverviewTutorial: false
      };

    case COMPLETE_KNOWLEDGE_GRAPH_TUTORIAL:
      return {
        ...state,
        runKnowledgeGraphTutorial: false
      };

    case COMPLETE_WHAT_CAN_I_ASK_TUTORIAL:
      return {
        ...state,
        runWhatCanIAskTutorial: false
      };

    case COMPLETE_FIRST_ACCESS_TUTORIAL:
      return {
        ...state,
        hasFinishedFirstAccessTutorial: true
      };

    case USER_SUCCESS: {
      const { tutorials } = action.data;
      return {
        ...state,
        tutorials,
        uncompletedTutorials: tutorials && tutorials.filter(tut => tut.isUncompleted)
      };
    }

    case TUTORIAL_FINISHED_REQUEST: {
      const tutorials = [...state.tutorials.filter(tut => tut.id !== action.data.id), action.data];
      return {
        ...state,
        tutorials,
        uncompletedTutorials: tutorials && tutorials.filter(tut => tut.isUncompleted)
      };
    }

    default:
      return state;
  }
}
